import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail'
import { useNavState } from '../../../common/navState/NavStateContext'
import { Ndc9ProdList } from '../ndc9Prod/Ndc9ProdList'
import { LabelerForm } from './LabelerForm'

export const LabelerDetail = () => {

  const { navState } = useNavState();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <LabelerForm /> },
    { id: 'ndc9Tab', label: 'NDC9s', content: <Ndc9ProdList labelerId={navState.entityId} /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}